var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gaming-pad-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.50014 11H10.5001M8.50014 9V13M15.5001 12H15.5101M18.5001 10H18.5101M10.9491 5H14.0512C16.6761 5 17.9885 5 19.0187 5.49743C19.9257 5.9354 20.6793 6.63709 21.1808 7.51059C21.7503 8.5027 21.8438 9.81181 22.0309 12.43L22.2769 15.8745C22.3975 17.5634 21.0599 19 19.3667 19C18.5008 19 17.6796 18.6154 17.1253 17.9502L16.7501 17.5C16.407 17.0882 16.2354 16.8823 16.04 16.7159C15.6305 16.3672 15.1346 16.1349 14.6045 16.0436C14.3516 16 14.0836 16 13.5476 16H11.4527C10.9167 16 10.6487 16 10.3958 16.0436C9.86563 16.1349 9.36981 16.3672 8.96024 16.7159C8.76487 16.8823 8.59329 17.0882 8.25013 17.5L7.87497 17.9502C7.32064 18.6154 6.49949 19 5.63359 19C3.94037 19 2.60275 17.5634 2.72339 15.8745L2.96942 12.43C3.15644 9.81181 3.24994 8.5027 3.81951 7.51059C4.32098 6.63709 5.07458 5.9354 5.98159 5.49743C7.01176 5 8.3242 5 10.9491 5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/game.990d0a31dffc48ebdeec39a6764334b6.svg";
export { ForwardRef as ReactComponent };